export enum $finding {
  _id = '_id',
  findingId = 'findingId',
  ruleTitle = 'ruleTitle',
  ruleId = 'ruleId',
  url = 'url',
  pageTitle = 'pageTitle',
  pageId = 'pageId',
  createdOn = 'createdOn',
  severity = 'severity',
  status = 'status',
  task = 'task',
  hasTask = 'hasTask',
  taskId = 'taskId',
  successCriteria = 'successCriteria',
  tool = 'tool',
  flawOccurrence = 'flawOccurrence',
  toolId = 'toolId',
  firstFound = 'firstFound',
  lastFound = 'lastFound',
  statusHistory = 'statusHistory',
  data = 'data',
}

export enum $findings {
  findings = 'findings',
  _total = '_total',
}

export enum DigitalAssetFindingsSortBy {
  viewed = 'viewed',
  createdOn = 'firstFound.date',
  lastFound = 'lastFound.date',
  status = 'status',
}

export enum DigitalAssetFindingsFilterQueryOptions {
  // used for selecting
  findingId = 'findingId',
  ruleId = 'ruleId',
  ruleTitle = 'ruleTitle',
  pageUrl = 'pageUrl',
  createdOn = 'createdOn',
  taskProjectId = 'taskProjectId',
  severities = 'severities',
  statuses = 'statuses',
  hasTask = 'hasTask',
  tool = 'tool',
  successCriteria = 'successCriteria',
}
